import { render, staticRenderFns } from "./ProgramSelectionTab.vue?vue&type=template&id=507d8a5c"
import script from "./ProgramSelectionTab.vue?vue&type=script&lang=js"
export * from "./ProgramSelectionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports